import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const logto = defineConnector({
  identifier: "logto",
  name: "Logto",
  tagLine: "Identity infrastructure for developers",
  logo,
  protocol: "http",
  tags: ["identity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.logto\\.app/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Logto tenant",
      items: [
        {
          kind: "input",
          label: "Tenant domain",
          required: true,
          placeholder: "your-tenant.logto.app",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create a machine-to-machine app token",
      items: [
        {
          kind: "markdown",
          content:
            "In Logto, create a Machine-to-Machine app, assign the Management API role, and generate an access token. See the [API docs](https://docs.logto.io/integrate-logto/interact-with-management-api) for details.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/applications`,
  },
});
